import React from "react";



function FireMapBox() {

    let height = window.innerHeight;
    console.log(height)
    let heightvh = height*0.615 + "vh"
    console.log(heightvh)

    return (
        <div>
            <iframe src="firemap.html" width="100%" height={heightvh} style={{overflow: "none"}}/>
        </div>
    );

}

export default FireMapBox;


// API -> AIzaSyCCMQlB41vn2nIVOAHuTnt6nrk8QxpEf5o
